<template>
	<span class="brand-logo" :class="'is-' + variant" aria-hidden="true">
		<svg class="brand-mark" viewBox="0 0 32 32" fill="none">
			<rect width="32" height="32" rx="8" fill="#F15A24"/>
			<path d="M8.2 8.4h4.2v15.2H8.2V8.4z" fill="#fff"/>
			<path d="M23.6 10.15a7.15 7.15 0 1 0 0 11.7" stroke="#fff" stroke-width="4.2" stroke-linecap="round" fill="none"/>
		</svg>
		<span v-if="variant !== 'mark'" class="brand-name">IC Markets</span>
	</span>
</template>

<script>
export default {
	name: 'BrandLogo',
	props: {
		variant: {
			type: String,
			default: 'wordmark'
		}
	}
}
</script>

<style lang="scss" scoped>
.brand-logo {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	height: 100%;
	color: var(--ld-text, #111);
	line-height: 1;
}

.brand-mark {
	display: block;
	height: 100%;
	width: auto;
	aspect-ratio: 1;
	flex-shrink: 0;
}

.brand-name {
	font-size: 15px;
	font-weight: 750;
	letter-spacing: -0.045em;
	white-space: nowrap;
	line-height: 1;
}

.is-mark {
	gap: 0;
}
</style>
